export default __webpack_public_path__ + "fonts/ABBvoice_W_Bd-1DpC-.eot";